export const GET_SPECIALTIES_LOADING = "GET_SPECIALTIES_LOADING";
export const GET_SPECIALTIES_SUCCESS = "GET_SPECIALTIES_SUCCESS";
export const GET_SPECIALTIES_FAILURE = "GET_SPECIALTIES_FAILURE";
